import React from 'react';
import { Switch as AntSwitch, SwitchProps as AntSwitchProps } from 'antd';
import { createUseStyles } from 'react-jss';
import { ThemeType } from 'src/theming/jssTypes';

export interface SwitchProps extends AntSwitchProps {
  className?: string;
}

const useStyles = createUseStyles((theme: ThemeType) => ({
  switch: {
    backgroundColor: theme.color.semantic.background.neutral.strong,
    '& .ant-switch-handle::before': {
      backgroundColor: theme.color.semantic.background.neutral.subtle,
    },
    '&:not(.ant-switch-disabled)': {
      '&:hover': {
        backgroundColor: theme.color.semantic.background.neutral.soft,
      },
    },
    '&.ant-switch-checked': {
      backgroundColor: `${theme.color.semantic.brand.default.primary} !important`,
      borderColor: `${theme.color.semantic.brand.default.primary} !important`,
      '&:not(.ant-switch-disabled)': {
        '&:hover': {
          backgroundColor: `${theme.color.semantic.brand.default.primary} !important`,
        },
        '&:active, &:focus': {
          backgroundColor: `${theme.color.semantic.brand.default.primary} !important`,
        },
      },
      '&.ant-switch-disabled': {
        opacity: theme.opacity[40],
        backgroundColor: `${theme.color.semantic.brand.default.primary} !important`,
      },
    },
    '&.ant-switch-disabled': {
      opacity: theme.opacity[40],
      backgroundColor: theme.color.semantic.background.neutral.strong,
      cursor: 'not-allowed',
    },
    '&.ant-switch-loading': {
      opacity: theme.opacity[40],
      backgroundColor: theme.color.semantic.brand.default.primary,
    },
  },
}));

const Switch: React.FC<SwitchProps> = ({ className = '', ...rest }) => {
  const classes = useStyles();
  return <AntSwitch {...rest} className={`${classes.switch} ${className}`.trim()} />;
};

export default Switch;
